/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../../concepts/resources/Icon';
import { VideoStateAttr } from '../../packages/video/VideoAttributes';
import { YouTubeVideo } from '../../packages/video/YouTubeVideo';
import { Colors } from './../../../ui';
import { aspect } from './Aspect';
import { RenderBorder, RenderBounds } from './RenderHelpers';
import { VisualBase } from './VisualBase';

export class YouTubeVideoVisual extends VisualBase<YouTubeVideo> {

    private get isPlaying() {
        return VideoStateAttr.get(this.object) === 'playing';
    }

    @aspect()
    private get isUp() {
        const { interaction, isPressed } = this;
        return interaction?.type === 'invoke' && !isPressed;
    }

    @aspect()
    private get isDown() {
        const { interaction, isPressed } = this;
        return interaction?.type === 'invoke' && isPressed;
    }

    @aspect()
    private get borderStyling(): any {
        const { object } = this.props;

        return {
            width: object.width,
            height: object.height,
        };
    }

    public render() {
        return <RenderBounds object={this.object}>
            <RenderBorder pose={this.pose} style={this.borderStyling}>
                <iframe width={this.object.width} height={this.object.height}
                    data-video-src={this.object.id}
                    src={`https://www.youtube.com/embed/${this.object.videoId}?enablejsapi=1&controls=0`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                </iframe>
                {!this.isPlaying && <>
                    <RenderPreview src={`https://i.ytimg.com/vi/${this.object.videoId}/maxresdefault.jpg`} />
                    <RenderCover hover={this.isUp} active={this.isDown}>
                        <div>
                            <Icon src="deqo://icons/i8/play-fill" />
                        </div>
                    </RenderCover>
                </>}
            </RenderBorder>
        </RenderBounds>;
    }
}

const RenderPreview = styled.img`
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

const RenderCover = styled.div<{ hover?: boolean, active?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    ${p => p.hover ? 'background: rgba(0, 0, 0, .2);' : ''}
    ${p => p.active ? 'background: rgba(0, 0, 0, .4);' : ''}

    & > div {
        background: rgb(255 255 255 / 75%);
        border-radius: 40px;
        padding: 32px 48px;

        & > svg {
            position: relative;
            width: 160px;
            height: 160px;
            color: ${Colors.primary};
        }
    }
`;
